import { render } from "./ModelImageGallery.vue?vue&type=template&id=45906bd5&scoped=true"
import script from "./ModelImageGallery.vue?vue&type=script&lang=js"
export * from "./ModelImageGallery.vue?vue&type=script&lang=js"

import "./ModelImageGallery.vue?vue&type=style&index=0&id=45906bd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45906bd5"]])

export default __exports__